import { memo } from 'react';
import './style.scss';
import Skeleton from 'react-loading-skeleton';
import { WHLogRowCell } from '../WHLogListRow/WHLogListRow';
import { WH_LOG_COLUMN } from '../../constants/WHLogRow';

const WHLogListRowSkeleton = (): JSX.Element => {
  const skeletonClassName = 'cell-skeleton';

  return (
    <div className="branch-log-list branch-log-skeleton">
      <WHLogRowCell cellName={WH_LOG_COLUMN.PROFILE}>
        <Skeleton height={16} className={skeletonClassName} />
      </WHLogRowCell>
      <WHLogRowCell cellName={WH_LOG_COLUMN.DATE}>
        <Skeleton height={16} className={skeletonClassName} />
      </WHLogRowCell>
      <WHLogRowCell cellName={WH_LOG_COLUMN.ACTION}>
        <Skeleton height={16} className={skeletonClassName} />
      </WHLogRowCell>
      <WHLogRowCell cellName={WH_LOG_COLUMN.AUTHOR}>
        <Skeleton height={16} className={skeletonClassName} />
      </WHLogRowCell>
      <WHLogRowCell cellName={WH_LOG_COLUMN.DETAILS}>
        <Skeleton height={16} className={skeletonClassName} />
      </WHLogRowCell>
    </div>
  );
};

export default memo(WHLogListRowSkeleton);
